function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.854 4.646a.5.5 0 010 .708L5.207 8l2.647 2.646a.5.5 0 01-.708.708l-3-3a.5.5 0 010-.708l3-3a.5.5 0 01.708 0z",
  clipRule: "evenodd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.5 8a.5.5 0 01.5-.5h6.5a.5.5 0 010 1H5a.5.5 0 01-.5-.5z",
  clipRule: "evenodd"
});

function SvgLeftArrow(props) {
  return React.createElement("svg", _extends({
    className: "left-arrow_svg__bi left-arrow_svg__bi-arrow-left-short",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iYmkgYmktYXJyb3ctbGVmdC1zaG9ydCIgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTcuODU0IDQuNjQ2YS41LjUgMCAwMTAgLjcwOEw1LjIwNyA4bDIuNjQ3IDIuNjQ2YS41LjUgMCAwMS0uNzA4LjcwOGwtMy0zYS41LjUgMCAwMTAtLjcwOGwzLTNhLjUuNSAwIDAxLjcwOCAweiIgY2xpcC1ydWxlPSJldmVub2RkIi8+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNC41IDhhLjUuNSAwIDAxLjUtLjVoNi41YS41LjUgMCAwMTAgMUg1YS41LjUgMCAwMS0uNS0uNXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4=";
export { SvgLeftArrow as ReactComponent };